<script>
    // import CloseButton from "$lib/images/close-btn.svg"
    import backArrow from "$lib/images/back-arrow.svg";
    import { t, locale } from "$lib/translations";
    import { selectStep } from "/src/store";

    import Form from "./Form.svelte";

    export let stepData;
    export let nextStep;
    export let prevStep;
    export let openModal;

    let isIpCopied = false;

    const copyIpToClipboard = () => {
        isIpCopied = true;
        navigator.clipboard.writeText("start.unrealrp.com.ua");
    };
</script>

<section class="section-steps">
    <div class="section-wrapper">
        <h1 class="title {$locale}">
            {$t("how_to_play.step_title")}
        </h1>
        <div class="step-container">
            <div class="image">
                <img src={stepData.image} alt="Person1" />
            </div>
            <div class="text">
                <!--				<a href="/"><div class="close-btn">-->
                <!--					<img src={CloseButton} alt="Close">-->
                <!--				</div></a>-->
                {#if stepData.id === 2 || stepData.id === 3 || stepData.id === 4}
                    <div class="wrapper-back">
                        <button class="btn btn-secondary" on:click={prevStep}>
                            <img class="back-arrow" src={backArrow} alt="Back Arrow" />
                            {$t("how_to_play.step_back")}
                        </button>
                    </div>
                {/if}
                <div class="main-text">
                    <h2 class="title">
                        {#if !stepData.form}
                            {stepData.step}: <span class="bold">{stepData.stepName}</span>
                        {:else if stepData.form}
                            {#if $selectStep === "register"}
                                КРОК 1: <span class="bold">РЄСТРАЦІЯ</span>
                            {:else if $selectStep === "authorization"}
                                КРОК 1: <span class="bold">АВТОРИЗАЦІЯ</span>
                            {:else if $selectStep === "confirm-email"}
                                КРОК 1: <span class="bold">ПІДТВЕРДЖЕННЯ ПОШТИ</span>
                            {/if}
                        {/if}
                    </h2>
                    {#if !stepData.form}
                        <div class="description">
                            {@html stepData.description}
                        </div>
                    {:else if stepData.form}
                        <Form {nextStep} ; />
                    {/if}
                </div>
                <div class="buttons">
                    {#if stepData.ip}
                        <div class="ip-wrapper">
                            <p>{stepData.ip}</p>
                            <div class="row">
                                <a>
                                    <button
                                        class="btn btn-primary"
                                        class:active={isIpCopied}
                                        on:click={copyIpToClipboard}
                                        >{isIpCopied ? $t("how_to_play.copied") : $t("how_to_play.copy")}
                                    </button>
                                </a>
                            </div>
                        </div>
                    {/if}
                    <div class="row up">
                        {#if stepData.ip}
                            <div class="step-button" style="width: 100%">
                                <a href={$t("how_to_play.rules_link")} target="_blank">
                                    <button class="btn btn-primary ip">{$t("how_to_play.rules_button")}</button>
                                </a>
                            </div>
                        {/if}
                        {#each stepData.buttons.slice(0, 2) as button, index}
                            <div class="step-button">
                                {#if stepData.id === 1 && index === 0}
                                    <button class="btn btn-primary" on:click={nextStep}>{button}</button>
                                {:else if stepData.id === 1 && index === 1}
                                    <a
                                        href="https://store.steampowered.com/app/271590/Grand_Theft_Auto_V/"
                                        target="_blank"
                                    >
                                        <button class="btn btn-primary">{button}</button>
                                    </a>
                                {:else if stepData.id === 2 && index === 0}
                                    <a href="https://rage.mp/" target="_blank">
                                        <button class="btn btn-primary">{button}</button>
                                    </a>
                                {:else if stepData.id === 2 && index === 1}
                                    <button class="btn btn-primary" on:click={nextStep}>{button}</button>
                                {:else if stepData.id === 3 && index === 0}
                                    <a href={$t("how_to_play.discord_link")} target="_blank">
                                        <button class="btn btn-primary">{button}</button>
                                    </a>
                                {:else if stepData.id === 3 && index === 1}
                                    <button class="btn btn-primary" on:click={nextStep}>{button}</button>
                                {:else if stepData.id === 4 && index === 0}
                                    <a href="{$locale}/">
                                        <button class="btn btn-primary" on:click={copyIpToClipboard}>{button}</button>
                                    </a>
                                {:else if stepData.id === 4 && index === 1}
                                    <a href={$t("how_to_play.rules_link")} target="_blank">
                                        <button class="btn btn-primary" on:click={copyIpToClipboard}>{button}</button>
                                    </a>
                                {:else}
                                    <button class="btn btn-primary">{button}</button>
                                {/if}
                            </div>
                        {/each}
                    </div>
                    <div class="row down">
                        {#each stepData.buttons.slice(2, 3) as button}
                            <div class="step-button">
                                <a>
                                    <button class="btn btn-primary" on:click={openModal}>{button}</button>
                                </a>
                            </div>
                        {/each}
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<style lang="scss">
    @import "/src/lib/scss/main";
    @import "/src/lib/scss/responsible";

    @mixin button {
        border: 1px solid rgba(255, 255, 255, 0.2);
        background-color: transparent;
        color: rgba(255, 255, 255, 0.6);
        font-style: italic;
    }

    @media screen and (max-width: 1400px) {
        .section-wrapper {
            padding: 40px 0 40px 0 !important;
        }

        .main-text {
            & > .title {
                font-size: 30px !important;
            }
            & > .description {
                font-size: 18px !important;
            }
        }

        .wrapper-back {
            img {
                width: 30px !important;
                height: 30px !important;
            }
        }

        .step-container {
            justify-content: center !important;
            padding: 0 10px !important;

            & > .image {
                display: none;
            }

            & > .text {
                text-align: center;
                //margin-top: 40px;
                margin: 0 !important;
                gap: 25px !important;
                max-width: none !important;
                width: 600px !important;
                //width: 580px;

                & > .main-text {
                    width: auto !important;
                    gap: 20px !important;
                    //padding: 0 15px 0 15px;

                    & > .description {
                        width: auto !important;
                    }
                }

                & > .buttons {
                    .ip-wrapper {
                        height: 50px !important;

                        p {
                            font-size: 13px !important;
                        }

                        .row {
                            width: 120px !important;
                            height: 30px !important;
                        }

                        button {
                            font-size: 9pt !important;
                        }
                    }

                    .row {
                        height: 50px;
                    }

                    .step-button {
                        height: 100% !important;
                    }

                    button {
                        height: 100%;
                        font-size: 15px !important;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 400px) {
        .main-text {
            & > .title {
                font-size: 35px !important;
            }
            & > .description {
                font-size: 16px !important;
            }
        }
    }

    section {
        //background-image: url(/src/lib/images/pattern.svg);
        //background-repeat: no-repeat;
        //background-position: center;
        //background-attachment: local;
        //background-size: contain;
        //position: absolute;
        //top: 0;
        //left: 0;
        //bottom: 0;
        //right: 0;
        //margin: 0;
        //backdrop-filter: blur(15px);
        //background-color: #1E1E1E;
        //z-index: 100;
        //width: 100%;
        //height: 100%;
        //overflow: hidden;

        & > .section-wrapper {
            width: 100%;
            height: 100%;
            //position: relative;
            display: flex;
            flex-direction: column;
            @include fluid("gap", 40);
            align-items: center;
            @include fluid("padding-right", 150);
            @include fluid("padding-left", 150);
            @include fluid("padding-bottom", 60);

            & > .title {
                //-webkit-text-stroke: 1px #FED500;
                @include fluid("text-stroke", 1, "#FED500");
                @include fluid("-webkit-text-stroke", 1, "#FED500");
                //text-stroke: 1px #FED500;
                //font-size: calc(10px + 8vw);
                font-size: 9.1vw;
                white-space: nowrap;
                line-height: 120%;
                text-transform: uppercase;
                font-weight: 800;
                font-style: italic;
                color: transparent;

                &.en {
                    font-size: 5.5vw !important;
                }

                &.ge {
                    font-size: 6.1vw !important;
                }

                &.pl {
                    font-size: 6.4vw !important;
                }

                &.fr {
                    font-size: 4.7vw !important;
                }
            }

            & > .step-container {
                display: flex;
                justify-content: space-evenly;
                align-items: center;
                width: 100%;
                //position: relative;
                height: 100%;
                //padding: 0 14.5rem;
                //@include fluid("padding-right", 130);
                //@include fluid("padding-left", 130);

                @keyframes animImage {
                    0% {
                        transform: translateY(0);
                    }
                    50% {
                        transform: translateY(10px);
                    }
                    100% {
                        transform: translateY(0);
                    }
                }

                & > .image {
                    //position: absolute;
                    animation: animImage infinite 4s;
                    transition: transform 0.3s;
                    //@include fluid("bottom", 1);
                    //@include fluid("left", 1);
                    @include fluid("width", 480);
                    @include fluid("height", 496);
                }
                & > .text {
                    @include fluid("max-width", 580);
                    display: flex;
                    flex-direction: column;
                    @include fluid("gap", 20);
                    @include fluid("margin-right", 40);

                    .wrapper-back {
                        display: flex;
                        align-items: center;
                        width: fit-content;

                        button {
                            color: rgba(255, 255, 255, 0.6);
                            width: auto;
                            display: flex;
                            align-items: center;
                            @include fluid("gap", 10);
                            transition: 0.2s;

                            &:hover {
                                color: #ffffff;

                                .back-arrow {
                                    content: url("/src/lib/images/back-arrow-hover.svg");
                                }
                            }
                        }
                    }

                    .back-arrow {
                        @include fluid("width", 30);
                        @include fluid("height", 30);
                        transition: 0.2s;
                    }

                    //position: relative;

                    //& > a > .close-btn {
                    //	width: 35px;
                    //	position: absolute;
                    //	right: 0;
                    //}

                    & > .main-text {
                        display: flex;
                        flex-direction: column;
                        @include fluid("gap", 20);
                        //margin-top: 2rem;
                        //width: 600px;

                        & > .title {
                            color: white;
                            @include fluid("font-size", 40);
                            line-height: 120%;
                            font-style: italic;
                            font-weight: 300;
                            text-transform: uppercase;

                            & > .bold {
                                font-weight: 600;
                            }
                        }

                        & > .description {
                            text-align: justify;
                            font-weight: 300;
                            @include fluid("font-size", 18);
                            line-height: 134%;
                            color: rgba(255, 255, 255, 0.6);
                        }
                    }

                    & > .buttons {
                        display: flex;
                        flex-direction: column;
                        @include fluid("gap", 20);
                        width: 100%;
                        align-self: self-end;

                        button {
                            @include fluid("font-size", 18);
                        }

                        & > .ip-wrapper {
                            width: 100%;
                            background: transparent;
                            @include fluid("border", 1, "solid #FED500");
                            @include fluid("height", 64);
                            @include fluid("border-radius", 4);
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            @include fluid("padding-right", 20);
                            @include fluid("padding-left", 20);

                            p {
                                font-weight: 900;
                                font-style: italic;
                                @include fluid("font-size", 18);
                                line-height: 120%;
                                color: #fffbef;
                            }

                            .row {
                                @include fluid("width", 179);
                                @include fluid("height", 38);
                            }

                            a {
                                text-decoration: none;
                            }

                            button {
                                text-transform: none;
                                font-weight: 900;
                                font-style: italic;
                                @include fluid("font-size", 16);
                                line-height: 120%;

                                &.active {
                                    background-color: #fff !important;
                                }
                            }
                        }

                        & > .row {
                            display: flex;
                            width: 100%;
                            @include fluid("gap", 20);

                            & > .step-button {
                                & > a {
                                    text-decoration: none;
                                }

                                & > a > button,
                                & > button {
                                    font-weight: 900;
                                }
                            }

                            &.up {
                                width: 100%;

                                & > .step-button:nth-child(1) {
                                    width: 90%;
                                    @include fluid("height", 64);

                                    & > a > button,
                                    & > button {
                                        color: #232323;
                                        font-style: italic;

                                        &.ip {
                                            @include button;
                                        }
                                    }
                                }

                                & > .step-button:nth-child(2) {
                                    width: 70%;
                                    @include fluid("height", 64);

                                    & > a > button,
                                    & > button {
                                        @include button;
                                    }
                                }
                            }

                            &.down {
                                & > .step-button {
                                    @include fluid("height", 64);

                                    &:nth-child(1) {
                                        width: 100%;

                                        & > a > button {
                                            @include button;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
